import * as React from "react"
import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {Grid, TablePagination} from "@mui/material";
import {translateCountryName} from "@ui-seeker/utils";
import {CardSeeker} from "@ui-seeker/core";

import {LabelCountry, PercentageChartNew} from "@components";
import {BANNERS_ROUTES} from "@constants";
import {useBannerPercentageDynamic, useBannersPercentageLink} from "../@hooks";
import BannersPercentageDynamicSkeleton from "./Skeleton";
import BannerPercentageToolbar from "../Toolbar";


export default function BannersPercentageDynamic() {
    const {
        isLoading, data, isCountryAgg, totalKey, shareKey, handleChangeTotalKey, handleChangeShareKey, excludeOptions, totalTitle,
        isClickedRemaining, shareTitle, handleDownload
    } = useBannerPercentageDynamic()
    const { buildLink } = useBannersPercentageLink(BANNERS_ROUTES.TOP_BANNERS_PATH)

    const page = useSignal(0)
	const rowsPerPage = useSignal(25)

    useEffect(() => {
		page.value = 0
	}, [totalKey, shareKey, data.length])

    if (isLoading) return <BannersPercentageDynamicSkeleton isLoading={isLoading} />
    if (!data.length) return <></>

    const paginatedData = data.slice(page.value * rowsPerPage.value, (page.value + 1) * rowsPerPage.value)

    return <CardSeeker
        title={`Dynamic analytics by ${totalTitle} & ${shareTitle}`}
        actions={<BannerPercentageToolbar
            splitBySelected={totalKey}
            groupedBySelected={shareKey}
            onChangeSplitBy={handleChangeTotalKey}
            onChangeGroupedBy={handleChangeShareKey}
            excludeOptions={excludeOptions}
            onDownload={handleDownload}
        />}
    >
        <Grid container spacing={0}>
            {paginatedData.map(({ label, country, rows, highLevelPercentage, ...rowData }, idx) => (<Grid item key={idx} xs={12}>
                <PercentageChartNew
                    label={<LabelCountry
                        ellipsis
                        maxWidth={{ lg: 60, xl: 110 } }
                        label={!isCountryAgg ? label : translateCountryName(country)}
                        country={country}
                    />}
                    highLevelPercentage={highLevelPercentage}
                    data={rows.map(d => ({
                        ...d,
                        width: d.share,
                        prevWidth: d.prevShare,
                        diff: d.diff,
                        link: d.remainingData
                            ? d.remainingData.length && isClickedRemaining ? buildLink({country, ...rowData, ...d}) : null
                            : buildLink({country, ...rowData, ...d})
                    }))}
                />
            </Grid>))}
        </Grid>

        <TablePagination
            component="div"
            count={data.length}
            page={page.value}
            onPageChange={(_, newPage) => page.value = newPage}
            rowsPerPage={rowsPerPage.value}
            onRowsPerPageChange={(e) => {
                rowsPerPage.value = parseInt(e.target.value, 10)
                page.value = 0
            }}
            rowsPerPageOptions={[25, 50, 100]}
        />
    </CardSeeker>
}